import React, { Component } from 'react'

import Header from '../Header'

import style from './style.css'
import global from '../style.css'
export default class Boxtext extends Component {
    render() {
        let data = this.props.data
        return(
            <div className={`${global.box} ${ this.props.needApprove ? global.needApprove : '' }`}>
                <Header
                    is_admin={this.props.is_admin}
                    data={data}
                    needApprove={this.props.needApprove}
                    actionDelete={(id) => this.props.handleDelete(id) }
                    onApprove={() => this.props.onApprove()}/>
                <div
                    style={{
                        fontSize: data.content.length > 80 ? '15px' : '30px'
                    }}
                    className={style.content}>
                    {data.content}
                </div>
                {this.props.children}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Timeline/Containers/BoxText/index.js